const OAuth2Config = {
  OAUTH2_ENABLE: process.env.REACT_APP_OAUTH2_ENABLE === 'true' || false,
  ENABLE_FACEBOOK_LOGIN: process.env.REACT_APP_ENABLE_FACEBOOK_LOGIN === 'true' || false,
  ENABLE_GOOGLE_LOGIN: process.env.REACT_APP_ENABLE_GOOGLE_LOGIN === 'true' || false,
  ENABLE_TWITTER_LOGIN: process.env.REACT_APP_ENABLE_TWITTER_LOGIN === 'true' || false,
};

export default OAuth2Config;
